module.exports = __webpack_public_path__ + "static/media/bussiness_policy_img1.d962720f.png";